import styled from "styled-components";

const Backdrop = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(#5b65f9, #202bcd);
    padding: 64px;
`;

const ImgBoundary = styled.div`
    flex: 1;
    max-height: 600px;
    max-width: 600px;
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export function OnboardingImagePanel(props: { src: string }) {
    return (
        <Backdrop>
            <ImgBoundary>
                <Img src={props.src} />
            </ImgBoundary>
        </Backdrop>
    );
}
